import Vue from 'vue'
import qs from 'qs'

export default {
  getAll (options) {
    return Vue.http.get(`/products`, {
      params: options,
      paramsSerializer: qs.stringify
    })
  },

  get (id) {
    return Vue.http.get(`/products/${id}`)
  },

  patch (id, data) {
    // Fix Laravel patch route not accept multipart/form-data encode type
    if (data instanceof FormData) {
      data.append('_method', 'PATCH')
      return Vue.http.post(`/products/${id}`, data)
    }

    return Vue.http.patch(`/products/${id}`, data)
  },

  store (data) {
    return Vue.http.post(`/products`, data)
  },

  delete (id) {
    return Vue.http.delete(`/products/${id}`)
  },

  getLocations (id) {
    return Vue.http.get(`/products/${id}/locations`)
  },

  getParentCombos (id) {
    return Vue.http.get(`/products/${id}/parent_combos`)
  }
}



// WEBPACK FOOTER //
// ./src/services/product.js